// Hack para los webcomponents de RH
import Vue from "vue";
window.Vue = Vue;

export default Vue;
